import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FillWidthCell from '../../../../../app/components/FillWidthCell';

export const TableHeader = React.memo(() => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell width="50px" align="left" sx={{ fontWeight: 'bold' }}>
        #
      </TableCell>
      <FillWidthCell align="left" sx={{ fontWeight: 'bold' }}>
        {t('table.list.header.table')}
      </FillWidthCell>
      <TableCell align="right" sx={{ fontWeight: 'bold', width: '120px' }}>
        {t('table.list.header.actions')}
      </TableCell>
    </TableRow>
  );
});
